import getConfig from 'next/config';
import type { TagsListProps } from './TagsList.typed';
import { FreeHistoryReportTag } from '../../Toolkit/Tags/PreBuilt/FreeHistoryReportTag';
import { GreenLightTag } from '../../Toolkit/Tags/PreBuilt/GreenlightTag';
import { Tag } from '../../Toolkit/Tags/Tag';
import * as Styled from '../../../components/AdCard/TagsList/TagsList.styled';

const TagsList = ({ tags, className }: TagsListProps) => {
  const {
    publicRuntimeConfig: { FEATURE_PRICING_INDICATOR },
  } = getConfig();
  return (
    <Styled.Container className={className}>
      {tags?.map(({ displayName, type }) => {
        if (type === 'greenlight') {
          return <GreenLightTag key={displayName} />;
        }

        if (!FEATURE_PRICING_INDICATOR && type === 'freeHistoryReport') {
          return <FreeHistoryReportTag key={displayName} />;
        }
        return (
          <Tag key={displayName} text={displayName} textColor={'GREY_DARK'} />
        );
      })}
    </Styled.Container>
  );
};

export { TagsList };
